import { Workbook } from "exceljs";
import {
  excelHelper,
  fileHelper,
  formatHelper,
} from "../../../../common/helpers";
/**
 *
 * @param {any[]} customerBalance
 * @returns {Workbook}
 */
export const exportExcel = async (
  customerBalance,
  selectedStore,
  startDate,
  endDate
) => {
  let totalIncome = 0;
  let totalQuantity = 0;
  const excelData = [];
  for (let item = 0; item < customerBalance.length; item++) {
    const balance = customerBalance[item];

    excelData.push({
      order: item + 1,
      customer: `${balance.name} ${balance.lastname}`,
      quantity: balance.quantity,
      total: balance.total,
    });

    totalIncome += balance.total;
    totalQuantity += balance.quantity;
  }

  excelData.push({
    order: "",
    customer: "TOTAL",
    quantity: totalQuantity,
    total: totalIncome,
  });
  const json = excelHelper.jsonToJson(
    [excelData],
    [
      {
        name: "BALANCE POR CLIENTE",
        props: [
          {
            inValue: "order",
            outValue: "",
          },
          {
            inValue: "customer",
            outValue: "CLIENTE",
          },
          {
            inValue: "quantity",
            outValue: "CANTIDAD",
          },
          {
            inValue: "total",
            outValue: "TOTAL RECAUDADO",
          },
        ],
      },
    ]
  );
  const workbook = excelHelper.jsonToExcelJs(json);
  const fileName = getFileName(selectedStore, startDate, endDate);
  const blob = await excelHelper.workbookToBlob(workbook);
  fileHelper.downloadBlob(blob, fileName);
};

const getFileName = (selectedStore, startDate, endDate) => {
  const storeName = selectedStore.label;
  return selectedStore.value == 0
    ? formatHelper.toDateYYMMDD(new Date().toUTCString()) +
        "_reporte-general-por-cliente_" +
        formatHelper.toDateYYMMDD(startDate._d) +
        "_" +
        formatHelper.toDateYYMMDD(endDate._d) +
        ".xlsx"
    : formatHelper.toDateYYMMDD(new Date().toUTCString()) +
        "_reporte-por-cliente_" +
        storeName.toLowerCase() +
        "_" +
        formatHelper.toDateYYMMDD(startDate._d) +
        "_" +
        formatHelper.toDateYYMMDD(endDate._d) +
        ".xlsx";
};



// WEBPACK FOOTER //
// ./src/scenes/Report/Balance/CustomersBalance/excel.js